'use strict';
// Piezas comunes de la API del paquete (index.js e importacion.js).
const P = require('./prototipo');

const SCHEMAS_ACEPTADOS = ['sustemia.energia.v1', 'sustemia.energia.v2'];

const clonar = (o) => JSON.parse(JSON.stringify(o));

// El motor guarda la fecha de referencia y el uso (A/B) en variables del prototipo: se fijan antes de cada cálculo.
// Todas las funciones son sincrónicas, así que dos cálculos no se pisan.
function fijarContexto({ fechaReferencia = null, modo = 'A' } = {}) {
  if (fechaReferencia != null && !/^\d{4}-\d{2}-\d{2}$/.test(fechaReferencia)) {
    throw new Error('fechaReferencia debe ser AAAA-MM-DD');
  }
  if (modo !== 'A' && modo !== 'B') throw new Error('modo debe ser «A» o «B»');
  P._setFECHA_REF(fechaReferencia);
  P._setMODO(modo);
}

// Primeros pasos de importSustemia() del prototipo: forma del archivo, estructura y colecciones vacías.
// Devuelve la instalación en forma interna (serie en _monthly), todavía sin normalizar.
// permitirSinMeses: para mostrar y editar una instalación que todavía no tiene consumos cargados (la importación
// de un archivo los sigue exigiendo).
function inicializarDesdeArchivo(obj, { permitirSinMeses = false } = {}) {
  if (!obj || !SCHEMAS_ACEPTADOS.includes(obj.schema) || !obj.instalacion) {
    throw new Error('El archivo no cumple el esquema sustemia.energia (v1 o v2)');
  }
  const inst = obj.instalacion;
  if (!inst.id || !String(inst.id).trim()) throw new Error('Falta el campo requerido: id');
  P.validarEstructura(inst);
  const f = clonar(inst);
  f._monthly = f.consumos_mensuales || f._monthly || [];
  delete f.consumos_mensuales;
  if (!f._monthly.length && !permitirSinMeses) throw new Error('La instalación no trae consumos mensuales (evidencias de facturas y producción)');
  ['seus', 'machinery', 'operations'].forEach((k) => { if (!Array.isArray(f[k])) f[k] = []; });
  if (f.name == null || f.name === '') f.name = String(inst.id);
  f._ejemplo = inst._ejemplo === true;
  f.fuentes = f.fuentes || [];
  f.combustibles = Array.isArray(f.combustibles) ? f.combustibles : [];
  P.subreqInit(f);
  f.tarifas = f.tarifas || {};
  f.factores = f.factores || {};
  f.ecms = f.ecms || [];
  f.docs = f.docs || [];
  f.idens = f.idens || [];
  f.alcanceRev = f.alcanceRev || 'Pendiente de revisión';
  f.clauseImplementation = f.clauseImplementation || {};
  f.femTypes = f.femTypes || [];
  f.processes = f.processes || [];
  f.lines = f.lines || [];
  return f;
}

module.exports = { clonar, fijarContexto, inicializarDesdeArchivo };
